export const SET_LANG_ENGLISH = "SET_LANG_ENGLISH";
export const SET_LANG_SPANISH = "SET_LANG_SPANISH";
